module.exports = new __parcel__URL__("banner-strand-bottom-left.dd754bad.png").toString();